<script context="module">
    export function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    export function parseDateFromString(dateString) {
        if (!dateString) return (new Date());

        let date = dateString.replace( /[-]/g, '/' );
        date = Date.parse( date );

        return new Date( date );
    }

    export function dateToSqlFormat(date) {
        return date.toISOString().slice(0, 19).replace('T', ' ');
    }

    export function calcTimeByOffset(offset) {
        const d = new Date();

        // convert to msec
        // subtract local time zone offset
        // get UTC time in msec
        const utc = d.getTime() + (d.getTimezoneOffset() * 60000);

        // create new Date object for different city
        // using supplied offset
        const nd = new Date(utc + (3600000 * offset));

        return nd;
    }

    export function num_word(value, words){
        if (!words || words.length < 3) return;
        value = Math.abs(value) % 100;
        const num = value % 10;
        if(value > 10 && value < 20) return words[2];
        if(num > 1 && num < 5) return words[1];
        if(num == 1) return words[0];
        return words[2];
    }

    export function getOuterHeight(element) {
        var elmHeight, elmMargin;
        if(document.all) {// IE
            elmHeight = element.currentStyle.height;
            elmMargin = parseInt(element.currentStyle.marginTop, 10) + parseInt(element.currentStyle.marginBottom, 10);
        } else {// Mozilla
            elmHeight = document.defaultView.getComputedStyle(element, '').getPropertyValue('height');
            elmMargin = parseInt(document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-top')) + parseInt(document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-bottom'));
        }

        elmHeight = parseInt(elmHeight);
        elmMargin = parseInt(elmMargin);
        return Number(elmHeight+elmMargin);
    }

    export function getOuterWidth(element) {
        var elmWidth, elmMargin;
        if(document.all) {// IE
            elmWidth = element.currentStyle.width;
            elmMargin = parseInt(element.currentStyle.marginLeft, 10) + parseInt(element.currentStyle.marginRight, 10);
        } else {// Mozilla
            elmWidth = document.defaultView.getComputedStyle(element, '').getPropertyValue('width');
            elmMargin = parseInt(document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-left')) + parseInt(document.defaultView.getComputedStyle(element, '').getPropertyValue('margin-right'));
        }

        elmWidth = parseInt(elmWidth);
        elmMargin = parseInt(elmMargin);
        return Number(elmWidth+elmMargin);
    }

    export function validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
</script>